import { WorkTimeSlot } from "modules/calendar-worktime-holiday";
import { API_endpoints } from "../config";

export const addWorkBlock = async (block : WorkTimeSlot) => {
    try {
        const response = await fetch(API_endpoints.addWorkBlock, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ ...block }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Adsieren von Bolck.");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Fehler beim Adsieren von Bolck:", error);
        throw error;
    }
};
